import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {DimensionalType} from "~/enums/dimensionalType";

/**
 * Class representing the interface between a ModelMappingValue and the model value of interest
 * (e.g. form element, object model property, Salesforce field)
 */
export default abstract class ModelMappingValueOrigin<T = any, MMO extends ModelMappingOrigin = ModelMappingOrigin> {
  abstract origin: T
  abstract value: Pick<IDefaultVOption, 'label'>
  /**
   * "number" | "readonly", etc, something that shows in parentheses to give context to value
   */
  abstract valueType: string;
  abstract isIndexed: boolean
  abstract isUploader: boolean;
  abstract isSinglePicklist: boolean
  abstract isMultiPicklist: boolean

  constructor(public id: string, protected modelMappingOrigin: MMO) {
  }

  /**
   * By default, the value does not represent a record ID (object model entry id, possibly salesforce object id?)
   * Override this getter in subclass
   */
  get isRecordId(): boolean {
    return false
  }

  get fileDimensionalType(): DimensionalType {
    return null;
  }
}